import CreateCategoryPageComponent from "./components/CreateCategoryPageComponent";
import axios from "axios";
import {
  uploadCategoryImagesApiRequest,
  uploadImagesCloudinaryApiRequest,
} from "./utils/utils";
import { useSelector } from "react-redux";
import { newCategory,deleteCategory, saveAttributeToCatDoc } from "../../redux/actions/categoryActions";
import { useDispatch } from "react-redux";

const createCategoryApiRequest = async (formInputs) => {
  const { data } = await axios.post(`/api/categories`, { ...formInputs });
  return data;
};

const AdminCreateCategoryPage = () => {
  const { categories } = useSelector((state) => state.getCategories);
  const dispatch = useDispatch();

  return (
    <CreateCategoryPageComponent
      createCategoryApiRequest={createCategoryApiRequest}
      uploadCategoryImagesApiRequest={uploadCategoryImagesApiRequest}
      uploadImagesCloudinaryApiRequest={uploadImagesCloudinaryApiRequest}
      categories={categories}
      reduxDispatch={dispatch}
      newCategory={newCategory}
      deleteCategory={deleteCategory}
      saveAttributeToCatDoc={saveAttributeToCatDoc}
    />
  );
};

export default AdminCreateCategoryPage;
